export const EN = require('./en.json')
